export default __webpack_public_path__ + "static/media/eu-mic_logo.6a84d1f3.png";